module.exports = __webpack_public_path__ + "img/img_03.c6ffe572.png";